const MY_DATA_ORG_CODE = {
  // 인증기관
  ORG_KFTC: 'ZXAAEA0000',
  // 사단법인 금융결제원
  ORG_KOSCOM: 'ZXAACP0000',
  // (주)코스콤
  ORG_SIGNGATE: 'ZXAACA0000',
  // 한국정보인증주식회사

  // 은행
  BK_KB: 'A1AAEO0000',
  // KB국민
  BK_SHINHAN: 'A1AAER0000',
  // 신한
  BK_HANA: 'A1AAES0000',
  // 하나
  BK_WOORI: 'A1AAEM0000',
  // 우리
  BK_KAKAO: 'A1AAHJ0000',
  // 카카오뱅크
  BK_K: 'A1AAJB0000',
  // 케이뱅크
  BK_IBK: 'A1AAEQ0000',
  // IBK기업
  BK_NH: 'A1AABG0000',
  // NH농협
  BK_KDB: 'A1AAAD0000',
  // KDB산업
  BK_SC: 'A1AAAK0000',
  // SC제일
  BK_BUSAN: 'A1AAII0000',
  // 부산
  BK_DAEGU: 'A1AAHS0000',
  // 대구
  BK_KYOUNGNAM: 'A1AAIM0000',
  // 경남
  BK_SH: 'A1AAHX0000',
  // 수협
  BK_KWANGJU: 'A1AAMW0000',
  // 광주
  BK_JEONBUK: 'A1AAHP0000',
  // 전북
  BK_JEJU: 'A1AAIP0000',
  // 제주
  BK_EPOST: 'A1AAKA0000',
  // 우체국
  BK_TOSS: 'A1AAPF0000',
  // 토스뱅크
  BK_HF: 'A1AAOU0000',
  // 주택금융공사
  BK_KOSAF: 'A1AAOV0000',
  // 한국장학재단
  BK_KINFA: 'A1AAOW0000',
  // 서민금융진흥원
  BK_KFCC: 'A4AAPA0000',
  // 새마을금고
  BK_CU: 'A4AAKM0000',
  // 신협
  BK_SHCENTRAL: 'A4AAGD0000',
  // 수협중앙회
  BK_NHCENTRAL: 'A4AAAZ0000',
  // 농협중앙회
  BK_CITI: 'A1AAQE0000',
  // 씨티은행
  BK_NFCF: 'A4AAGC0000',
  // 산림조합중앙회

  // 금융투자(증권)
  IV_MIRAE: 'C1AACU0000',
  // 미래에셋
  IV_KIWOOM: 'C1AABR0000',
  // 키움
  IV_KB: 'C1AADA0000',
  // KB증권
  IV_SAMSUNG: 'C1AAEY0000',
  // 삼성
  IV_KOREA: 'C1AACT0000',
  // 한국투자
  IV_SHINHAN: 'C1AADF0000',
  // 신한금융투자
  IV_NH: 'C1AACQ0000',
  // NH투자
  IV_HANA: 'C1AAKN0000',
  // 하나금융투자
  IV_DAISHIN: 'C1AAKO0000',
  // 대신
  IV_KAKAOPAY: 'C1AAGU0000',
  // 카카오페이증권
  IV_TOSS: 'C1AAHW0000',
  // 토스증권
  IV_MERITZ: 'C1AACZ0000',
  // 메리츠종금
  IV_YUANTA: 'C1AADC0000',
  // 유안타
  IV_KYOBO: 'C1AACS0000',
  // 교보
  IV_EUGENE: 'C1AADB0000',
  // 유진투자
  IV_HM: 'C1AADD0000',
  // 현대차증권
  IV_DBFI: 'C1AADI0000',
  // DB금융투자
  IV_HI: 'C1AAIJ0000',
  // 하이투자
  IV_LS: 'C1AABQ0000',
  // LS증권
  IV_HANWHA: 'C1AACY0000',
  // 한화투자
  IV_SK: 'C1AAPW0000',
  // SK
  IV_DAOL: 'C1AAPV0000',
  // 다올투자증권 - (구)KTB
  IV_SHINYOUNG: 'C1AAJE0000',
  // 신영
  IV_FOSS: 'C1AAQD0000',
  // 한국포스증권
  IV_IBK: 'C1AABU0000',
  // IBK투자증권
  IV_WOORI: 'C1AAPD0000',
  // 우리종합금융 주식회사
  IV_HANKUK: 'C1AACO0000',
  // 한국증권금융
  IV_BNK: 'C1AAIK0000',
  // BNK투자증권
  IV_CAPE: 'C1AABV0000',
  // 케이프투자증권
  IV_BOOKOOK: 'C1AAJN0000',
  // 부국증권
  IV_SSIN: 'C1AACV0000',
  // 상상인증권

  // 카드
  CD_SHINHAN: 'D1AAEX0000',
  // 신한카드
  CD_SAMSUNG: 'D1AAEV0000',
  // 삼성카드
  CD_KB: 'D1AAAF0000',
  // KB국민카드
  CD_HYUNDAI: 'D1AAFO0000',
  // 현대카드
  CD_BC: 'D1AAFQ0000',
  // 비씨카드
  CD_HANA: 'D1AABJ0000',
  // 하나카드
  CD_WOORI: 'D1AAAH0000',
  // 우리카드
  CD_LOTTE: 'D1AADO0000',
  // 롯데카드
  CD_NH: 'D1AABG0000',
  // NH농협카드
  CD_IBK: 'D1AAEQ0000',
  // IBK기업카드
  CD_SC: 'D1AAAK0000',
  // SC제일카드
  CD_KDB: 'D1AAAD0000',
  // KDB산업카드
  CD_KFCC: 'D1AAPA0000',
  // 새마을금고카드
  CD_EPOST: 'D1AAKA0000',
  // 우체국카드
  CD_CU: 'D1AAKM0000',
  // 신협카드
  CD_SH: 'D1AAHX0000',
  // 수협카드
  CD_DAEGU: 'D1AAHS0000',
  // 대구은행카드
  CD_KWANGJU: 'D1AAMW0000',
  // 광주은행카드
  CD_BUSAN: 'D1AAII0000',
  // 부산은행카드
  CD_KYOUNGNAM: 'D1AAIM0000',
  // 경남은행카드
  CD_JEONBUK: 'D1AAHP0000',
  // 전북은행카드
  CD_HYUNDAI_DS: 'D2AAPG0000',
  // 현대백화점카드
  CD_GALLERIA_DS: 'D2AAOD0000',
  // 갤러리아백화점카드
  CD_TOSS_BANK: 'D1AAPF0000',
  // 토스뱅크카드
  CD_K_BANK: 'D1AAJB0000',
  // 케이뱅크카드
  CD_KAKAO_BANK: 'D1AAHJ0000',
  // 카카오뱅크카드
  CD_JEJU_BANK: 'D1AAIP0000',
  // 제주은행카드
  CD_CITI_BANK: 'D1AAQE0000',
  // 씨티카드
  CD_MIRAE_STOCK: 'D1AACU0000',
  // 미래에셋증권
  CD_KB_STOCK: 'D1AADA0000',
  // KB증권카드
  CD_HANKOOK_STOCK: 'D1AACT0000',
  // 한국투자증권카드
  CD_NH_STOCK: 'D1AACQ0000',
  // NH투자증권카드
  CD_YUANTA_STOCK: 'D1AADC0000',
  // 유안타증권카드
  CD_SK_STOCK: 'D1AAPW0000',
  // SK증권카드
  CD_HANWHA_STOCK: 'D1AACY0000',
  // 한화투자증권카드

  // 저축은행
  SB_SMART: 'A3AAMR0000',
  // 스마트저축
  SB_TRUE: 'A3AANF0000',
  // 참저축
  SB_CENTRAL: 'A3AAMS0000',
  // 센트럴저축
  SB_DOUBLE: 'A3AAMT0000',
  // 더블저축
  SB_DONGYANG: 'A3AAMV0000',
  // 동양저축
  SB_DAEHAN: 'A3AAMX0000',
  // 대한저축
  SB_KOREAINVEST: 'A3AAMY0000',
  // 한국투자저축
  SB_STAR: 'A3AAMZ0000',
  // 스타저축
  SB_MS: 'A3AANA0000',
  // 엠에스저축
  SB_DAEBAEK: 'A3AANB0000',
  // 대백저축
  SB_UNION: 'A3AANC0000',
  // 유니온저축
  SB_DAEAH: 'A3AAND0000',
  // 대아저축
  SB_DAISHIN: 'A3AALW0000',
  // 대신저축
  SB_SAMHO: 'A3AAMQ0000',
  // 삼호저축
  SB_OHTOO: 'A3AAMP0000',
  // 오투저축
  SB_ASAN: 'A3AAMO0000',
  // 아산저축
  SB_SSINPLUS: 'A3AAMN0000',
  // 상상인플러스
  SB_WOORIFIN: 'A3AAMK0000',
  // 우리금융저축
  SB_CK: 'A3AAMI0000',
  // CK저축
  SB_THEK: 'A3AAMF0000',
  // 더케이저축
  SB_KIWOOMYES: 'A3AAME0000',
  // 키움예스
  SB_KB: 'A3AAMC0000',
  // KB저축
  SB_BARO: 'A3AALZ0000',
  // 바로저축
  SB_YUANTA: 'A3AALY0000',
  // 유안타저축
  SB_OK: 'A3AALX0000',
  // OK저축
  SB_MUSTSAMIL: 'A3AANE0000',
  // 머스트삼일
  SB_DONGWONJEIL: 'A3AANT0000',
  // 동원제일저축
  SB_OHSUNG: 'A3AAPT0000',
  // 오성저축
  SB_BNK: 'A3AAPS0000',
  // BNK저축
  SB_DAEWON: 'A3AAPR0000',
  // 대원저축
  SB_DAEMYUNG: 'A3AAPQ0000',
  // 대명저축
  SB_HANSUNG: 'A3AAPP0000',
  // 한성저축
  SB_CHUNGJU: 'A3AAPO0000',
  // 청주저축
  SB_KIWOOM: 'A3AANX0000',
  // 키움저축
  SB_DREAM: 'A3AANG0000',
  // 드림저축
  SB_SOLBRAIN: 'A3AANS0000',
  // 솔브레인저축
  SB_JINJU: 'A3AANR0000',
  // 진주저축
  SB_CHOHEUNG: 'A3AANQ0000',
  // 조흥저축
  SB_IBK: 'A3AANP0000',
  // IBK저축
  SB_SNT: 'A3AANO0000',
  // 에스앤티저축
  SB_DH: 'A3AANN0000',
  // 디에이치저축
  SB_WOORI: 'A3AANM0000',
  // 우리저축
  SB_COREA: 'A3AANK0000',
  // 고려저축
  SB_KOOKJE: 'A3AANJ0000',
  // 국제저축
  SB_HEUNGKUK: 'A3AANI0000',
  // 흥국저축
  SB_RAON: 'A3AANH0000',
  // 라온저축
  SB_PURUN: 'A3AAKL0000',
  // 푸른저축
  SB_ANYANG: 'A3AAKY0000',
  // 안양저축
  SB_PEPPER: 'A3AAKX0000',
  // 페퍼저축
  SB_KUMHWA: 'A3AAKW0000',
  // 금화저축
  SB_WELCOME: 'A3AAKU0000',
  // 웰컴저축
  SB_SHINHAN: 'A3AAKT0000',
  // 신한저축
  SB_JTCHINE: 'A3AAKS0000',
  // JT친애저축
  SB_NH: 'A3AAKR0000',
  // NH저축
  SB_DAOL: 'A3AAKP0000',
  // 다올저축
  SB_ACUON: 'A3AALT0000',
  // 애큐온저축
  SB_HB: 'A3AAKK0000',
  // ㈜HB저축
  SB_OSB: 'A3AAKJ0000',
  // OSB_저축
  SB_YEKARAM: 'A3AAKE0000',
  // 예가람저축
  SB_HANA: 'A3AAKB0000',
  // 하나저축
  SB_SBI: 'A3AAJZ0000',
  // SB_I저축
  SB_DB: 'A3AAJY0000',
  // 디비저축
  SB_SKY: 'A3AALU0000',
  // 스카이저축
  SB_PYUNGTAEK: 'A3AALA0000',
  // 평택저축
  SB_MK: 'A3AALQ0000',
  // 민국저축
  SB_CHOEUN: 'A3AALP0000',
  // 조은저축
  SB_YOONGCHANG: 'A3AALN0000',
  // 융창저축
  SB_NAMYANG: 'A3AALM0000',
  // 남양저축
  SB_INSUNG: 'A3AALL0000',
  // 인성저축
  SB_MOA: 'A3AALK0000',
  // 모아저축
  SB_INCHEON: 'A3AALI0000',
  // 인천저축
  SB_HANWHA: 'A3AALH0000',
  // 한화저축
  SB_YOUNGJIN: 'A3AALG0000',
  // 영진저축
  SB_JT: 'A3AALF0000',
  // JT저축
  SB_ANGUK: 'A3AALE0000',
  // 안국저축
  SB_SSIN: 'A3AALD0000',
  // 상상인저축
  SB_SERAM: 'A3AALC0000',
  // 세람저축
  SB_SAMJUNG: 'A3AALB0000',
  // 삼정저축
  SB_BOORIM: 'A3AAKZ0000',
  // 부림저축

  // 보험
  IS_SAMSUNGFIRE: 'B2AAEW0000',
  // 삼성화재
  IS_HI: 'B2AAAL0000',
  // 현대해상
  IS_DBFIRE: 'B2AAEN0000',
  // DB손해보험(동부)
  IS_KBFIRE: 'B2AALR0000',
  // KB손해보험(LIG)
  IS_MERITZFIRE: 'B2AACR0000',
  // 메리츠화재보험
  IS_AXA: 'B2AACL0000',
  // AXA손해보험
  IS_HANWHAFIRE: 'B2AADH0000',
  // 한화손해보험
  IS_NHFIRE: 'B2AAOC0000',
  // NH농협손해보험
  IS_HANAFIRE: 'B2AABT0000',
  // 하나손해보험
  IS_LOTTE: 'B2AAAT0000',
  // 롯데손해보험
  IS_AIGFIRE: 'B2AAAG0000',
  // AIG손해보험(차티스)
  IS_HEUNGKUKFIRE: 'B2AANY0000',
  // 흥국화재해상보험(쌍용)
  IS_CARROT: 'B2AAIF0000',
  // 캐롯손해
  IS_MG: 'B2AAGZ0000',
  // MG손해보험(그린)
  IS_BNPFIRE: 'B2AAQG0000',
  // BNP파리바카디프손해보험
  IS_LINAFIRE: 'B2AADJ0000',
  // 라이나손해보험

  IS_SAMSUNGLIFE: 'B1AAAR0000',
  // 삼성생명보험
  IS_HANWHALIFE: 'B1AAQI0000',
  // 한화생명보험
  IS_KYOBOLIFE: 'B1AAAI0000',
  // 교보생명보험
  IS_SHINHAN: 'B1AAAS0000',
  // 신한생명보험
  IS_LINALIFE: 'B1AAAY0000',
  // 라이나생명보험
  IS_NHLIFE: 'B1AABF0000',
  // NH농협생명보험
  IS_DONGYANG: 'B1AAEU0000',
  // 동양생명보험
  IS_AIGLIFE: 'B1AAIX0000',
  // AIA생명보험(AIG)
  IS_MIRAE: 'B1AAHE0000',
  // 미래에셋생명보험
  IS_HEUNGKUKLIFE: 'B1AAAO0000',
  // 흥국생명보험
  IS_FUBON: 'B1AAQA0000',
  // 푸본현대생명
  IS_ABL: 'B1AAFP0000',
  // ABL생명보험(알리안츠)
  IS_KDB: 'B1AAMU0000',
  // KDB생명보험(금호)
  IS_DGB: 'B1AANL0000',
  // DGB생명보험(우리아비바)
  IS_MET: 'B1AADN0000',
  // 메트라이프생명보험
  IS_DBLIFE: 'B1AAET0000',
  // DB생명보험(동부)
  IS_KB_PRUDENTIAL: 'B1AAJM0000',
  // 푸르덴셜생명보험
  IS_HANALIFE: 'B1AAFS0000',
  // 하나생명보험
  IS_CHUBBLIFE: 'B1AADM0000',
  // 처브라이프생명보험(ACE)
  IS_LIFEPLANET: 'B1AAJH0000',
  // 교보라이프플래닛보험
  IS_BNPLIFE: 'B1AAKD0000',
  // BNP파리바카디프생명보험
  IS_SGIC: 'B4AADL0000',
  // 서울보증보험
  IS_KOREAPOST: 'B1AAKA0000',
  // 우정사업본부
  IS_IBKI: 'B1AABD0000',
  // IBK연금
  IS_KAKAO_PAY_FIRE: 'B2ABBH0000',
  // 카카오페이손해보험

  // 캐피탈
  CAPITAL_KB_CARD: 'D3AAAF0000',
  // KB국민카드
  CAPITAL_WOORI_CARD: 'D3AAAH0000',
  // 우리카드
  CAPITAL_OK: 'D3AAAJ0000',
  // OK캐피탈
  CAPITAL_RCI: 'D3AAAW0000',
  // RCI파이낸셜
  CAPITAL_MOORIM: 'D3AABA0000',
  // 무림캐피탈
  CAPITAL_VOLKSWAGEN: 'D3AABC0000',
  // 폭스바겐파이낸셜
  CAPITAL_HANA_CARD: 'D3AABJ0000',
  // 하나카드
  CAPITAL_M: 'D3AABL0000',
  // M캐피탈
  CAPITAL_MERITZ: 'D3AABW0000',
  // 메리츠캐피탈
  CAPITAL_KICF: 'D3AABY0000',
  // 한국투자캐피탈
  CAPITAL_PORSCHE: 'D3AACM0000',
  // 포르쉐파이낸셜
  CAPITAL_HYUNDAI: 'D3AADE0000',
  // 현대캐피탈
  CAPITAL_LOTTE_CARD: 'D3AADO0000',
  // 롯데카드
  CAPITAL_ORIX: 'D3AADS0000',
  // 오릭스캐피탈
  CAPITAL_KB: 'D3AADZ0000',
  // KB캐피탈
  CAPITAL_CNH: 'D3AAEC0000',
  // 씨앤에이치캐피탈
  CAPITAL_LOTTE_AUTOLEASE: 'D3AAEF0000',
  // 롯데오토리스
  CAPITAL_VOLVO: 'D3AAEK0000',
  // 볼보파이낸셜
  CAPITAL_A: 'D3AAEP0000',
  // A캐피탈
  CAPITAL_SAMSUNG_CARD: 'D3AAEV0000',
  // 삼성카드
  CAPITAL_SHINHAN_CARD: 'D3AAEX0000',
  // 신한카드
  CAPITAL_KDBC: 'D3AAEZ0000',
  // KDB캐피탈
  CAPITAL_DB: 'D3AAFA0000',
  // DB캐피탈
  CAPITAL_ECO: 'D3AAFL0000',
  // 에코캐피탈
  CAPITAL_BC_CARD: 'D3AAFQ0000',
  // 비씨카드
  CAPITAL_ACUON: 'D3AAFW0000',
  // 애큐온캐피탈
  CAPITAL_HB: 'D3AAFX0000',
  // HB캐피탈
  CAPITAL_HANA: 'D3AAGE0000',
  // 하나캐피탈
  CAPITAL_DGB: 'D3AAGV0000',
  // iM캐피탈(DGB캐피탈)
  CAPITAL_DEUTSCH: 'D3AAHB0000',
  // 도이치파이낸셜
  CAPITAL_HANKOOK: 'D3AAHG0000',
  // 한국캐피탈
  CAPITAL_K_CAR: 'D3AAHH0000',
  // 케이카캐피탈
  CAPITAL_MASON: 'D3AAHK0000',
  // 메이슨캐피탈
  CAPITAL_MIRAE: 'D3AAHO0000',
  // 미래에셋캐피탈
  CAPITAL_JB_WOORI: 'D3AAHR0000',
  // JB우리캐피탈
  CAPITAL_SY: 'D3AAHV0000',
  // SY오토캐피탈
  CAPITAL_BNK: 'D3AAIL0000',
  // BNK캐피탈
  CAPITAL_KN: 'D3AAIM0000',
  // 경남은행
  CAPITAL_KIWWOOM: 'D3AAJC0000',
  // 키움캐피탈
  CAPITAL_WELCOME: 'D3AAJO0000',
  // 웰컴캐피탈
  CAPITAL_BMW: 'D3AAJX0000',
  // BMW파이낸셜
  CAPITAL_IBK: 'D3AAMG0000',
  // IBK캐피탈
  CAPITAL_WOORIF: 'D3AAMM0000',
  // 우리금융캐피탈
  CAPITAL_HYUNDAI_COMMERCIAL: 'D3AAOA0000',
  // 현대커머셜
  CAPITAL_NH: 'D3AAOB0000',
  // NH농협캐피탈
  CAPITAL_MERCEDES_BENZ: 'D3AAPX0000',
  // 벤츠파이낸셜
  CAPITAL_TOYOTA: 'D3AAQJ0000',
  // 토요타파이낸셜
  CAPITAL_LOTTE: 'D3AAQO0000',
  // 롯데캐피탈
  CAPITAL_SHINHAN: 'D3AAWG0000',
  // 신한캐피탈

  // 통신사
  TEL_SKT: 'F1AAAU0000',
  // SKT
  TEL_KT: 'F1AAAN0000',
  // KT
  TEL_LGU: 'F1AAGI0000',
  // LG유플러스
  TEL_SKB: 'F1AAFT0000',
  // SK브로드밴드
  TEL_HELLOVISION: 'F1AAOG0000',
  // LG헬로비전
  TEL_SKYLIFE: 'F1AADK0000',
  // KT스카이라이프
  TEL_DLIVE: 'F1AAJP0000',
  // 딜라이브
  TEL_CMB: 'F1AAHF0000',
  // CMB
  TEL_KTM: 'F1AAED0000',
  // 케이티엠모바일
  TEL_HCN: 'F1AAIC0000',
  // 현대HCN
  TEL_U: 'F1AACK0000',
  // U+알뜰모바일
  TEL_SK7: 'F1AAAV0000',
  // SK텔링크
  TEL_LIIVM: 'F1AAEO0000',
  // 리브모바일
  TEL_TOSS: 'F1AABP0000',
  // 토스모바일
  TEL_FINDIRECT: 'F1AAIZ0000',
  // 핀다이렉트
  TEL_S1: 'F1AAOH0000',
  // 안심모바일 (에스원)
  TEL_A: 'F1AADR0000',
  // 에이모바일
  TEL_KCT: 'F1AADT0000',
  // 티플러스 (한국케이블텔레콤)
  TEL_SEJONG: 'F1AAJQ0000',
  // 세종텔레콤
  TEL_FREET: 'F1AAFZ0000',
  // 프리티 (프리텔레콤)
  TEL_JCN: 'F1AAIN0000',
  // JCN울산중앙방송
  TEL_KONAI: 'F1AABZ0000',
  // 코나아이
  TEL_MOBING: 'F1AAEE0000',
  // 모빙
  TEL_EYES: 'F1AAOI0000',
  // 아이즈모바일
  TEL_NIB: 'F1AAOL0000',
  // 남인천방송
  TEL_INSCOBEE: 'F1AAIH0000',
  // 인스코비
  TEL_ACN: 'F1AAGW0000',
  // ACN코리아
  TEL_EG: 'F1AAGM0000',
  // 이지모바일
  TEL_KPMO: 'F1AAJS0000',
  // 한국피엠오
  TEL_YLLAND: 'F1AABB0000',
  // 와이엘랜드
  TEL_COINSHOT: 'F1AACF0000',
  // 코인샷
  TEL_WINNERSTEL: 'F1AABO0000',
  // 위너스텔
  TEL_ONKUKMIN: 'F1AAOO0000',
  // 온국민폰
  TEL_SMARTEL: 'F1AAGL0000',
  // 스마텔
  TEL_EYAGI: 'F1AAAM0000',
  // 이야기모바일

  POINT_11STREET: 'E1AAJA0000',
  // 11번가
  POINT_DGBUPAY: 'E1AAPY0000',
  // DGB유페이
  POINT_KGMOBILLIANCE: 'E1AAPB0000',
  // KG모빌리언스
  POINT_OKINVESTMENTPARTNERS: 'E1AAGT0000',
  // OK인베스트먼트파트너스
  POINT_OKCASHBACK: 'E1AABE0000',
  // ok캐시백
  POINT_PAYCO: 'E1AAIE0000',
  // PAYCO
  POINT_SKCOMMUNICATIONS: 'E1AAGH0000',
  // SK커뮤니케이션즈
  POINT_SMHIPLUS: 'E1AAZT0000',
  // SM하이플러스
  POINT_SSGPAY: 'E1AAPM0000',
  // SSG페이
  POINT_GOLFZONE: 'E1AAZG0000',
  // 골프존
  POINT_GOOGLEPAYMENTKOREA: 'E1AAPU0000',
  // 구글페이먼트코리아
  POINT_GLOBALMONEYEXPRESS: 'E1AAPJ0000',
  // 글로벌머니익스프레스
  POINT_NAVERPAY: 'E1AAHY0000',
  // 네이버페이
  POINT_CARROTPAY: 'E1AAYE0000',
  // 당근페이
  POINT_DECNCOMASSETMANAGEMENT: 'E1AADW0000',
  // 디셈버앤컴퍼니자산운용
  POINT_LOKAMOBILITY: 'E1AAWD0000',
  // 로카모빌리티
  POINT_LOTTESHOPPING: 'E1AAVE0000',
  // 롯데쇼핑
  POINT_MYBI: 'E1AAWE0000',
  // 마이비
  POINT_BAEMIN: 'E1AAQK0000',
  // 배달의민족
  POINT_BANKSALAD: 'E1AABN0000',
  // 뱅크샐러드
  POINT_BUSANHANAROCARD: 'E1AAWC0000',
  // 부산하나로카드
  POINT_BLUEWALNUT: 'E1AAIU0000',
  // 블루월넛
  POINT_SETTLEBANK: 'E1AAAC0000',
  // 세틀뱅크주식회사
  POINT_SMILEPAY: 'E1AAGP0000',
  // 스마일페이
  POINT_LPOINT: 'E1AABK0000',
  // 엘포인트
  POINT_WELCOMEPAYMENTS: 'E1AAHZ0000',
  // 웰컴페이먼츠
  POINT_WEMAKEPRICE: 'E1AAWB0000',
  // 위메프
  POINT_INTERPARK: 'E1AAGK0000',
  // 인터파크
  POINT_KAKAO: 'E1AAPC0000',
  // 카카오
  POINT_KAKAOBANK: 'E1AAHJ0000',
  // 카카오뱅크
  POINT_KAKAOPAY: 'E1AAIA0000',
  // 카카오페이
  POINT_KONAI: 'E1AABZ0000',
  // 코나아이
  POINT_COOCON: 'E1AAKF0000',
  // 쿠콘
  POINT_COUPANGPAY: 'E1AAPN0000',
  // 쿠팡페이
  POINT_TOSSPAYMENTS: 'E1AAZJ0000',
  // 토스페이먼츠
  POINT_TOSSPOINTS: 'E1AADV0000',
  // 토스
  POINT_TRAVELWALLET: 'E1AAIV0000',
  // 트래블월렛
  POINT_TMONEY: 'E1AAAX0000',
  // 티머니
  POINT_TIMON: 'E1AAFK0000',
  // 티몬
  POINT_FINSHOT: 'E1AACF0000',
  // 핀샷
  POINT_FINNQ: 'E1AAJI0000',
  // 핀크
  POINT_HANAMONEY: 'E1AABJ0000',
  // 하나머니
  POINT_KOREAPREPAIDCARD: 'E1AAOF0000',
  // 한국선불카드
  POINT_HANPAYSYS: 'E1AAWL0000' // 한페이시스

  /*
  POINT_UNITPOINT: 'D1AADO0000', // UNIT포인트
  POINT_TOP: 'D1AAFQ0000', // TOP
  POINT_BONUSPOINT: 'D1AAEV0000', // 보너스포인트
  POINT_MYSHINHANPOINT: 'D1AAEX0000', // 마이신한포인트
  POINT_WOORIWONHONEY: 'D1AAAH0000', // 우리WON꿀머니
  POINT_HANAPOINT: 'D1AABJ0000', // 하나포인트
  POINT_HCOIN: 'D1AAFO0000', // H-coin
  POINT_POINTREE: 'D1AAAF0000', // 포인트리
  POINT_NHPOINT: 'D1AABG0000', // NH포인트
  */
};
var MY_DATA_ORG_CODE$1 = MY_DATA_ORG_CODE;

export { MY_DATA_ORG_CODE$1 as default };
